import {FutureCalc} from "../../../../components/calculator/Calculator";
import FutureViewTable, {IFutureViewSettings} from "./FutureViewTable";
import PrintReport from "../../../../components/page/PrintReport";
import {dateToLocalFormat} from "../../../../stores/StoreUtilities";
import React, {useEffect, useState} from "react";
import {Box, FormLabel, Typography, useTheme} from "@mui/material";
import {useResources} from "../../../../stores/ResourceProvider";
import Model from "../../../../model/Model";
import FutureViewChart from "./FutureViewChart";


const FutureViewPrintReport = ({
  model,
  futureCalc,
  settings,
  width,
  isPrinting
} : {
  model: Model
  futureCalc?: FutureCalc,
  settings?: IFutureViewSettings
  width?: number
  isPrinting: boolean
}) => {
  const [currentModel, setCurrentModel] = useState<Model | undefined>()

  const {modelStore} = useResources()

  const theme = useTheme()
  const styles = {
    formLabel: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.grey["700"],
    },
  }

  useEffect(() => {
    if (model) {
      setCurrentModel(model)
    }
  }, [model])

  const getReportDetails = () => {
    const user = modelStore.currentUser
    if (user && currentModel) {
      const fullDate = dateToLocalFormat(new Date(), "MMM d, yyyy")
      return (
        <React.Fragment>
          <Box display="flex" alignItems="baseline">
            <Box width={50}><FormLabel sx={styles.formLabel}>Date:</FormLabel></Box>
            <Box><Typography variant="body2">{fullDate}</Typography></Box>
          </Box>
          <Box display="flex" alignItems="baseline">
            <Box width={50}><FormLabel sx={styles.formLabel}>Name:</FormLabel></Box>
            <Box><Typography variant="body2">{user!.fullName}</Typography></Box>
          </Box>
          <Box display="flex" alignItems="baseline">
            <Box width={50}><FormLabel sx={styles.formLabel}>Model:</FormLabel></Box>
            <Box><Typography variant="body2">{currentModel!.name} ({currentModel!.appliedPlan?.name})</Typography></Box>
          </Box>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  if (!futureCalc) {
    return null
  }

  // const innerWidth = window.innerWidth

  return (
    <PrintReport isPrinting={isPrinting}
                 title={`Future Report`}
                 details={getReportDetails()}
    >
      {/*<FutureViewChart year={futureCalc.startYear} futureCalcs={[futureCalc]} height={"300"} width={String(window.innerWidth - 200)}/>*/}
      <FutureViewTable year={futureCalc.startYear} futureCalcs={[futureCalc]}
                       settings={settings}
                       isPrinting={isPrinting}
      />
    </PrintReport>
  )
}

export default FutureViewPrintReport